export const mangroveSpeciesPerCountryList = [
  {
    country: {
      name: 'American Samoa',
      code: 'AS'
    },
    species: [
      'Acrostichum speciosum',
      'Bruguiera gymnorhiza',
      'Pemphis acidula',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Angola',
      code: 'AO'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Anguilla',
      code: 'AI'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Antigua and Barbuda',
      code: 'AG'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Australia',
      code: 'AU'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis annulata',
      'Aegiceras corniculatum',
      'Avicennia integra',
      'Avicennia marina',
      'Bruguiera cylindrica',
      'Bruguiera exaristata',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Camptostemon schultzii',
      'Ceriops australis',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Osbornia octodonta',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia lanceolata',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Bahamas',
      code: 'BS'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Bahrain',
      code: 'BH'
    },
    species: ['Avicennia marina']
  },
  {
    country: {
      name: 'Bangladesh',
      code: 'BD'
    },
    species: [
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis rotundifolia',
      'Aegiceras corniculatum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops decandra',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera fomes',
      'Kandelia candel',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia apetala',
      'Sonneratia caseolaris',
      'Sonneratia griffithii',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Barbados',
      code: 'BB'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Belize',
      code: 'BZ'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Benin',
      code: 'BJ'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Bermuda',
      code: 'BM'
    },
    species: ['Avicennia germinans', 'Rhizophora mangle']
  },
  {
    country: {
      code: 'BQ',
      name: 'Bonaire, Sint Eustatius and Saba'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Brazil',
      code: 'BR'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'British Indian Ocean Territory',
      code: 'IO'
    },
    species: ['Lumnitzera racemosa', 'Pemphis acidula']
  },
  {
    country: {
      name: 'Brunei Darussalam',
      code: 'BN'
    },
    species: [
      'Acanthus ebracteatus',
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Acrostichum speciosum',
      'Aegiceras corniculatum',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops tagal',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Cambodia',
      code: 'KH'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Aegiceras corniculatum',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Cameroon',
      code: 'CM'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Cayman Islands',
      code: 'KY'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'China',
      code: 'CN'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum speciosum',
      'Aegiceras corniculatum',
      'Avicennia marina',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera sexangula',
      'Ceriops tagal',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia obovata',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia ovata',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Christmas Island',
      code: 'CX'
    },
    species: [
      'Bruguiera gymnorhiza',
      'Bruguiera sexangula',
      'Cynometra iripa',
      'Heritiera littoralis',
      'Pemphis acidula'
    ]
  },
  {
    country: {
      name: 'Cocos (Keeling) Islands',
      code: 'CC'
    },
    species: ['Pemphis acidula']
  },
  {
    country: {
      name: 'Colombia',
      code: 'CO'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Mora oleifera',
      'Pelliciera rhizophorae',
      'Rhizophora mangle',
      'Rhizophora racemosa',
      'Rhizophora samoensis',
      'Tabebuia palustris'
    ]
  },
  {
    country: {
      name: 'Comoros',
      code: 'KM'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Congo',
      code: 'CG'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Congo, The Democratic Republic of the',
      code: 'CD'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Cook Islands',
      code: 'CK'
    },
    species: ['Pemphis acidula']
  },
  {
    country: {
      name: 'Costa Rica',
      code: 'CR'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Mora oleifera',
      'Pelliciera rhizophorae',
      'Rhizophora mangle',
      'Rhizophora racemosa',
      'Rhizophora samoensis',
      'Tabebuia palustris'
    ]
  },
  {
    country: {
      code: 'CI',
      name: "C\u00f4te d'Ivoire"
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Cuba',
      code: 'CU'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      code: 'CW',
      name: 'Cura\u00e7ao'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Djibouti',
      code: 'DJ'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Dominica',
      code: 'DM'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Dominican Republic',
      code: 'DO'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Ecuador',
      code: 'EC'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Mora oleifera',
      'Pelliciera rhizophorae',
      'Rhizophora racemosa',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Egypt',
      code: 'EG'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'El Salvador',
      code: 'SV'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Equatorial Guinea',
      code: 'GQ'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Eritrea',
      code: 'ER'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Fiji',
      code: 'FJ'
    },
    species: [
      'Bruguiera gymnorhiza',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Pemphis acidula',
      'Rhizophora samoensis',
      'Rhizophora stylosa',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'French Guiana',
      code: 'GF'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'French Polynesia',
      code: 'PF'
    },
    species: ['Pemphis acidula']
  },
  {
    country: {
      name: 'Gabon',
      code: 'GA'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Gambia',
      code: 'GM'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Ghana',
      code: 'GH'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Grenada',
      code: 'GD'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Guadeloupe',
      code: 'GP'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Guam',
      code: 'GU'
    },
    species: [
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora stylosa',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Guatemala',
      code: 'GT'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Equatorial Guinea',
      code: 'GQ'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Guinea-Bissau',
      code: 'GW'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Guyana',
      code: 'GY'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Haiti',
      code: 'HT'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Honduras',
      code: 'HN'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Hong Kong',
      code: 'HK'
    },
    species: ['Acanthus ilicifolius']
  },
  {
    country: {
      name: 'British Indian Ocean Territory',
      code: 'IO'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis rotundifolia',
      'Aegiceras corniculatum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops decandra',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera fomes',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia apetala',
      'Sonneratia caseolaris',
      'Sonneratia griffithii',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Indonesia',
      code: 'ID'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis annulata',
      'Aegialitis rotundifolia',
      'Aegiceras corniculatum',
      'Aegiceras floridum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Avicennia rumphiana',
      'Bruguiera cylindrica',
      'Bruguiera exaristata',
      'Bruguiera gymnorhiza',
      'Bruguiera hainesii',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Camptostemon philippinense',
      'Camptostemon schultzii',
      'Ceriops australis',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera globosa',
      'Heritiera littoralis',
      'Kandelia candel',
      'Kandelia obovata',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Osbornia octodonta',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia griffithii',
      'Sonneratia lanceolata',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      code: 'IR',
      name: 'Iran, Islamic Republic of'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Jamaica',
      code: 'JM'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Japan',
      code: 'JP'
    },
    species: [
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia obovata',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Sonneratia alba'
    ]
  },
  {
    country: {
      name: 'Kenya',
      code: 'KE'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Kiribati',
      code: 'KI'
    },
    species: [
      'Bruguiera gymnorhiza',
      'Lumnitzera littorea',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora stylosa',
      'Sonneratia alba'
    ]
  },
  {
    country: {
      name: 'Liberia',
      code: 'LR'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Macao',
      code: 'MO'
    },
    species: ['Acanthus ilicifolius']
  },
  {
    country: {
      name: 'Madagascar',
      code: 'MG'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Malaysia',
      code: 'MY'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegiceras corniculatum',
      'Aegiceras floridum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Avicennia rumphiana',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera hainesii',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops decandra',
      'Ceriops tagal',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera fomes',
      'Heritiera globosa',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Osbornia octodonta',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia griffithii',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Maldives',
      code: 'MV'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Excoecaria agallocha',
      'Lumnitzera racemosa',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Sonneratia caseolaris'
    ]
  },
  {
    country: {
      name: 'Marshall Islands',
      code: 'MH'
    },
    species: [
      'Bruguiera gymnorhiza',
      'Lumnitzera littorea',
      'Pemphis acidula',
      'Rhizophora stylosa',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Martinique',
      code: 'MQ'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Mauritania',
      code: 'MR'
    },
    species: ['Avicennia germinans', 'Conocarpus erectus', 'Rhizophora racemosa']
  },
  {
    country: {
      name: 'Mauritius',
      code: 'MU'
    },
    species: ['Bruguiera gymnorhiza', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Mayotte',
      code: 'YT'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Mexico',
      code: 'MX'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      code: 'FM',
      name: 'Micronesia, Federated States of '
    },
    species: [
      'Avicennia alba',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Montserrat',
      code: 'MS'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Mozambique',
      code: 'MZ'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Pemphis acidula',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Myanmar',
      code: 'MM'
    },
    species: [
      'Acanthus ebracteatus',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis rotundifolia',
      'Aegiceras corniculatum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops decandra',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera fomes',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia apetala',
      'Sonneratia caseolaris',
      'Sonneratia griffithii',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Nauru',
      code: 'NR'
    },
    species: [
      'Bruguiera gymnorhiza',
      'Lumnitzera littorea',
      'Rhizophora apiculata',
      'Rhizophora stylosa'
    ]
  },
  {
    country: {
      name: 'New Caledonia',
      code: 'NC'
    },
    species: [
      'Acrostichum speciosum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora samoensis',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'New Zealand',
      code: 'NZ'
    },
    species: ['Avicennia marina']
  },
  {
    country: {
      name: 'Nicaragua',
      code: 'NI'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Pelliciera rhizophorae',
      'Rhizophora mangle',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Nigeria',
      code: 'NG'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Niue',
      code: 'NU'
    },
    species: ['Acrostichum speciosum', 'Excoecaria agallocha']
  },
  {
    country: {
      name: 'Norfolk Island',
      code: 'NF'
    },
    species: ['Excoecaria agallocha']
  },
  {
    country: {
      name: 'Northern Mariana Islands',
      code: 'MP'
    },
    species: [
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora stylosa',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Oman',
      code: 'OM'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Pakistan',
      code: 'PK'
    },
    species: [
      'Acanthus ilicifolius',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Rhizophora mucronata'
    ]
  },
  {
    country: {
      name: 'Palau',
      code: 'PW'
    },
    species: [
      'Acanthus ebracteatus',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Avicennia alba',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Nypa fruticans',
      'Osbornia octodonta',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia ovata',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Panama',
      code: 'PA'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia bicolor',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Mora oleifera',
      'Pelliciera rhizophorae',
      'Rhizophora mangle',
      'Rhizophora racemosa',
      'Rhizophora samoensis',
      'Tabebuia palustris'
    ]
  },
  {
    country: {
      name: 'Papua New Guinea',
      code: 'PG'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis annulata',
      'Aegiceras corniculatum',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Avicennia rumphiana',
      'Bruguiera cylindrica',
      'Bruguiera exaristata',
      'Bruguiera gymnorhiza',
      'Bruguiera hainesii',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Camptostemon schultzii',
      'Ceriops australis',
      'Ceriops tagal',
      'Cynometra iripa',
      'Diospyros littorea',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Osbornia octodonta',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia lanceolata',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Peru',
      code: 'PE'
    },
    species: [
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora samoensis'
    ]
  },
  {
    country: {
      name: 'Philippines',
      code: 'PH'
    },
    species: [
      'Acanthus ebracteatus',
      'Acrostichum aureum',
      'Aegiceras corniculatum',
      'Aegiceras floridum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Avicennia rumphiana',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Camptostemon philippinense',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Osbornia octodonta',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Puerto Rico',
      code: 'PR'
    },
    species: ['Acrostichum aureum', 'Rhizophora mangle']
  },
  {
    country: {
      name: 'Qatar',
      code: 'QA'
    },
    species: ['Avicennia marina']
  },
  {
    country: {
      code: 'RE',
      name: 'R\u00e9union'
    },
    species: ['Bruguiera gymnorhiza', 'Rhizophora mucronata']
  },
  {
    country: {
      code: 'BL',
      name: 'Saint Barth\u00e9lemy'
    },
    species: [
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Saint Kitts and Nevis',
      code: 'KN'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Saint Lucia',
      code: 'LC'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      code: 'MF',
      name: 'Saint Martin (French part)'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Saint Vincent and the Grenadines',
      code: 'VC'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'American Samoa',
      code: 'AS'
    },
    species: ['Acrostichum speciosum', 'Bruguiera gymnorhiza', 'Rhizophora samoensis']
  },
  {
    country: {
      name: 'Sao Tome and Principe',
      code: 'ST'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Saudi Arabia',
      code: 'SA'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Senegal',
      code: 'SN'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Seychelles',
      code: 'SC'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Lumnitzera racemosa',
      'Pemphis acidula',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Sierra Leone',
      code: 'SL'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Singapore',
      code: 'SG'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegiceras corniculatum',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera hainesii',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops tagal',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      code: 'SX',
      name: 'Sint Maarten (Dutch part)'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Solomon Islands',
      code: 'SB'
    },
    species: [
      'Acanthus ebracteatus',
      'Acrostichum speciosum',
      'Aegiceras corniculatum',
      'Avicennia alba',
      'Avicennia marina',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops tagal',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Excoecaria indica',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Somalia',
      code: 'SO'
    },
    species: [
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'South Africa',
      code: 'ZA'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Lumnitzera racemosa',
      'Rhizophora mucronata',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Sri Lanka',
      code: 'LK'
    },
    species: [
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Aegiceras corniculatum',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Ceriops tagal',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Sudan',
      code: 'SD'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'Suriname',
      code: 'SR'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Taiwan, Province of China',
      code: 'TW'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Aegiceras corniculatum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia obovata',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Sonneratia alba'
    ]
  },
  {
    country: {
      name: 'Tanzania, United Republic of',
      code: 'TZ'
    },
    species: [
      'Acrostichum aureum',
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Ceriops tagal',
      'Heritiera littoralis',
      'Lumnitzera racemosa',
      'Pemphis acidula',
      'Rhizophora mucronata',
      'Sonneratia alba',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Thailand',
      code: 'TH'
    },
    species: [
      'Acanthus ebracteatus',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegialitis rotundifolia',
      'Aegiceras corniculatum',
      'Aglaia cucullata',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops decandra',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera fomes',
      'Heritiera littoralis',
      'Kandelia candel',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia griffithii',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Timor-Leste',
      code: 'TL'
    },
    species: ['Acanthus ilicifolius']
  },
  {
    country: {
      name: 'Togo',
      code: 'TG'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Tokelau',
      code: 'TK'
    },
    species: ['Pemphis acidula']
  },
  {
    country: {
      name: 'Tonga',
      code: 'TO'
    },
    species: [
      'Acrostichum speciosum',
      'Bruguiera gymnorhiza',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Rhizophora samoensis',
      'Rhizophora stylosa',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      name: 'Trinidad and Tobago',
      code: 'TT'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Turks and Caicos Islands',
      code: 'TC'
    },
    species: [
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Tuvalu',
      code: 'TV'
    },
    species: ['Lumnitzera littorea', 'Pemphis acidula', 'Rhizophora stylosa', 'Sonneratia alba']
  },
  {
    country: {
      name: 'United Arab Emirates',
      code: 'AE'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  },
  {
    country: {
      name: 'United States',
      code: 'US'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'United States Minor Outlying Islands',
      code: 'UM'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Pemphis acidula',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Vanuatu',
      code: 'VU'
    },
    species: [
      'Avicennia marina',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Ceriops tagal',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Lumnitzera littorea',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Xylocarpus granatum'
    ]
  },
  {
    country: {
      code: 'VE',
      name: 'Venezuela, Bolivarian Republic of'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Avicennia schaueriana',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle',
      'Rhizophora racemosa'
    ]
  },
  {
    country: {
      name: 'Viet Nam',
      code: 'VN'
    },
    species: [
      'Acanthus ebracteatus',
      'Acanthus ilicifolius',
      'Acrostichum aureum',
      'Acrostichum speciosum',
      'Aegiceras corniculatum',
      'Aegiceras floridum',
      'Avicennia alba',
      'Avicennia marina',
      'Avicennia officinalis',
      'Bruguiera cylindrica',
      'Bruguiera gymnorhiza',
      'Bruguiera parviflora',
      'Bruguiera sexangula',
      'Ceriops tagal',
      'Cynometra iripa',
      'Dolichandrone spathacea',
      'Excoecaria agallocha',
      'Heritiera littoralis',
      'Kandelia candel',
      'Kandelia obovata',
      'Lumnitzera littorea',
      'Lumnitzera racemosa',
      'Nypa fruticans',
      'Pemphis acidula',
      'Rhizophora apiculata',
      'Rhizophora mucronata',
      'Rhizophora stylosa',
      'Scyphiphora hydrophylacea',
      'Sonneratia alba',
      'Sonneratia caseolaris',
      'Sonneratia ovata',
      'Xylocarpus granatum',
      'Xylocarpus moluccensis'
    ]
  },
  {
    country: {
      name: 'Virgin Islands, British',
      code: 'VG'
    },
    species: [
      'Acrostichum aureum',
      'Acrostichum danaeifolium',
      'Avicennia germinans',
      'Conocarpus erectus',
      'Laguncularia racemosa',
      'Rhizophora mangle'
    ]
  },
  {
    country: {
      name: 'Wallis and Futuna',
      code: 'WF'
    },
    species: ['Acrostichum speciosum', 'Bruguiera gymnorhiza']
  },
  {
    country: {
      name: 'Yemen',
      code: 'YE'
    },
    species: ['Avicennia marina', 'Rhizophora mucronata']
  }
]
